import { useEffect, useState } from "react";
import Navigation from "./components/navigation";
import Header from "./components/sections/header";
import Contact from "./components/sections/contact";
import Cases from "./components/sections/cases";
import About from "./components/sections/about";
import Enquiry from "./components/sections/enquiry";
import ProjectPage from "./components/sections/project";
import { BackToTop } from "./components/controls/backtotop";
import { WhatsAppButton } from "./components/controls/whatsapp";
import Footer from "./components/sections/footer";

import "./App.css";

function App() {
  const [route, setRoute] = useState(window.location.hash);

  useEffect(() => {
    const onHashChange = () => setRoute(window.location.hash);
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const isAbout = route.startsWith("#/about");
  const projectMatch = route.match(/^#\/project\/([^/]+)\/(.+)$/);

  useEffect(() => {
    if (isAbout || projectMatch) {
      window.scrollTo(0, 0);
    } else if (route.length > 1) {
      // Coming back from the About page to a section link: the section
      // only exists after this render, so scroll on the next frame.
      requestAnimationFrame(() => {
        document.getElementById(route.slice(1))?.scrollIntoView();
      });
    }
  }, [route, isAbout]);

  if (isAbout) {
    return (
      <div className="App">
        <Navigation></Navigation>
        <About></About>
        <Footer></Footer>
        <BackToTop />
        <WhatsAppButton />
      </div>
    );
  }

  if (projectMatch) {
    return (
      <div className="App">
        <Navigation></Navigation>
        <ProjectPage
          category={decodeURIComponent(projectMatch[1])}
          title={decodeURIComponent(projectMatch[2])}
        ></ProjectPage>
        <Footer></Footer>
        <BackToTop />
        <WhatsAppButton />
      </div>
    );
  }

  return (
    <div className="App">
      <Navigation></Navigation>
      <Header></Header>
      <Cases pageTitle="Hospitality"></Cases>
      <Cases pageTitle="Commercial"></Cases>
      <Cases pageTitle="Residential"></Cases>
      <Enquiry></Enquiry>
      <Contact></Contact>
      <Footer></Footer>
      <BackToTop />
      <WhatsAppButton />
    </div>
  );
}

export default App;
